import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';

import useResponsive from '../../../../../hooks/useResponsive';
import Emoji from '../../../../../components/Emoji/Emoji';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 32,
    lineHeight: 1.25,
    fontWeight: 'bold',
  },
  mobileTitle: {
    fontSize: 20,
  },
}));

const NeedMoreInfoTitle = () => {
  const { isMobile } = useResponsive();
  const classes = useStyles();
  return (
    <Box pt={[3, 8]} pb={[3, 5]} mx={[2, 'auto']} color="text.primary" textAlign="center" fontSize={[20, 32]}>
      <Typography className={classNames(classes.title, { [classes.mobileTitle]: isMobile })}>
        <Emoji emoji="indexPointingUp" /> We need one more thing...
      </Typography>
    </Box>
  );
};

export default memo(NeedMoreInfoTitle);
